<div class="registration-container">
  <div
    class="card-wrapper"
    [ngClass]="{
      wide: step === 2,
      step4: step === 4,
      step3: step === 3,
      step2: step === 2,
      step1: step === 1
    }"
  >
    <div class="card">
      <div
        class="card-header"
        [ngClass]="{ step3: step === 3, step4: step === 4 }"
      >
        <div class="header-content">
          <div class="logo-container">
            <img src="assets/AivorLogo.png" alt="Aivor Logo" class="logo" />
          </div>
          <div class="header-text">
            <h1 class="title">Create Account</h1>
            <p class="subtitle">
              Complete the steps below to register your company
            </p>

            <!-- Step Indicators -->
            <div class="step-indicators">
              <div
                class="step-item"
                [ngClass]="{ active: step >= 1, completed: step > 1 }"
              >
                <div class="step-number">1</div>
                <div class="step-label">Company</div>
              </div>
              <div class="step-connector"></div>
              <div
                class="step-item"
                [ngClass]="{ active: step >= 2, completed: step > 2 }"
              >
                <div class="step-number">2</div>
                <div class="step-label">Admin User</div>
              </div>
              <div class="step-connector"></div>
              <div
                class="step-item"
                [ngClass]="{ active: step >= 3, completed: step > 3 }"
              >
                <div class="step-number">3</div>
                <div class="step-label">Terms</div>
              </div>
              <div class="step-connector"></div>
              <div class="step-item" [ngClass]="{ active: step >= 4 }">
                <div class="step-number">4</div>
                <div class="step-label">Payment</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!-- STEP 1: Tenant Name -->
        <form
          *ngIf="step === 1"
          [formGroup]="step1"
          (ngSubmit)="next()"
          class="registration-form"
        >
          <div class="form-group">
            <label for="tenantName" class="form-label">Company Name</label>
            <input
              id="tenantName"
              type="text"
              class="form-control"
              formControlName="tenantName"
              placeholder="Enter your company name"
              required
            />
            <div
              *ngIf="step1.get('tenantName')?.touched && step1.get('tenantName')?.errors?.['required']"
              class="form-error"
            >
              Company name is required
            </div>
            <div
              *ngIf="step1.get('tenantName')?.touched && step1.get('tenantName')?.errors?.['minlength']"
              class="form-error"
            >
              Company name must be at least 3 characters
            </div>
            <div
              *ngIf="step1.get('tenantName')?.touched && step1.get('tenantName')?.errors?.['maxlength']"
              class="form-error"
            >
              Company name cannot exceed 100 characters
            </div>
            <div
              *ngIf="step1.get('tenantName')?.touched && step1.get('tenantName')?.errors?.['pattern']"
              class="form-error"
            >
              Company name can only contain letters, numbers, spaces,
              underscores, and hyphens
            </div>
            <div *ngIf="tenantNameChecking" class="text-info mt-1">
              Checking availability...
            </div>
            <div
              *ngIf="tenantNameChecked && tenantNameAvailable"
              class="text-success mt-1"
            >
              This name is available!
            </div>
            <div
              *ngIf="tenantNameChecked && !tenantNameAvailable"
              class="text-danger mt-1"
            >
              {{ tenantNameError }}
            </div>
            <small class="form-text text-muted"
              >Your company name must be unique. We'll check availability as you
              type.</small
            >
          </div>

          <div class="form-actions">
            <button
              type="button"
              class="btn-secondary"
              [routerLink]="['/login']"
            >
              Back to Login
            </button>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="!step1.valid || !tenantNameAvailable"
            >
              Next
            </button>
          </div>
        </form>

        <!-- STEP 2: Admin User Details -->
        <form
          *ngIf="step === 2"
          [formGroup]="step2"
          (ngSubmit)="next()"
          class="registration-form"
        >
          <div class="profile-grid">
            <div class="form-group" *ngFor="let f of profileFields">
              <label [for]="f.key" class="form-label">{{ f.label }}</label>
              <input
                [id]="f.key"
                [type]="f.key === 'adminEmail' ? 'email' : 'text'"
                class="form-control"
                [formControlName]="f.key"
                [placeholder]="'Enter ' + f.placeholder"
                [ngClass]="{
                  'is-invalid':
                    (step2.get(f.key)?.invalid && step2.get(f.key)?.touched) ||
                    (f.key === 'adminEmail' && emailChecked && !emailAvailable)
                }"
                required
              />
              <div
                *ngIf="f.key === 'adminEmail' && emailChecking"
                class="text-info mt-1"
              >
                Checking email availability...
              </div>
              <div
                *ngIf="f.key === 'adminEmail' && emailChecked && emailAvailable"
                class="text-success mt-1"
              >
                This email is available!
              </div>
              <div
                *ngIf="
                  f.key === 'adminEmail' && emailChecked && !emailAvailable
                "
                class="text-danger mt-1"
              >
                {{ emailError }}
              </div>
              <div
                *ngIf="f.key === 'adminEmail' && step2.get('adminEmail')?.touched && step2.get('adminEmail')?.errors?.['email']"
                class="text-danger mt-1"
              >
                Please enter a valid email address
              </div>
              <div
                *ngIf="step2.get(f.key)?.touched && step2.get(f.key)?.errors?.['required']"
                class="form-error"
              >
                {{ f.label }} is required
              </div>
              <div
                *ngIf="f.key === 'adminEmail' && step2.get(f.key)?.touched && step2.get(f.key)?.errors?.['email']"
                class="form-error"
                `
              >
                Please enter a valid email address
              </div>
              <div
                *ngIf="f.key !== 'adminEmail' && step2.get(f.key)?.touched && step2.get(f.key)?.errors?.['maxlength']"
                class="form-error"
              >
                {{ f.label }} cannot exceed 50 characters
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn-secondary" (click)="prev()">
              Back
            </button>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="
                !step2.valid ||
                (step2.get('adminEmail')?.valid &&
                  (!emailChecked || !emailAvailable))
              "
            >
              Next
            </button>
          </div>
        </form>

        <!-- STEP 3: Terms & Conditions -->
        <form
          *ngIf="
            step === 3 && !isLoading && !registrationSuccess && !errorMessage
          "
          [formGroup]="step3"
          (ngSubmit)="next()"
          class="registration-form step3"
        >
          <div class="terms-container step3">
            <div class="terms-content step3">
              <span style="text-align: center">
                <h2>AIVOR Pty Ltd</h2>
              </span>

              <p>
                AIVOR Pty Ltd (Registration number 2024/781270/07) ("AIVOR,"
                "we" or "us") provides an AI-based costing and pricing software
                service ("the Service") through our website and mobile app. By
                signing up for an account or otherwise using the Service, you
                (the user, "you") agree to these Terms and Conditions. Please
                read these terms carefully before creating an account or making
                a purchase. If you do not agree, you must not use the Service.
              </p>

              <span>
                <h6>1. GEOGRAPHIC AVAILABILITY</h6>
                <p>
                  The Service is currently available only in Republic of South
                  Africa. By accepting these terms, you confirm that you are
                  accessing the Service from within Republic of South Africa and
                  are legally eligible to do so (e.g. you are 18 years or older
                  or otherwise have the legal capacity to enter into this
                  agreement).<br />We offer a 30-day trial for R1.00 to new
                  users. The 30 days allows you to access the full functionality
                  of the Service for 30 days at no charge. Each user (or
                  business) is entitled to one 30-day period. After the 30-day
                  trial for R1.00 ends, if you have not cancelled, your account
                  will automatically transition to a paid subscription plan.
                </p>
              </span>

              <span>
                <h6>2. SUBSCRIPTION OPTIONS</h6>
                <p>We provide monthly and annual subscription plans:</p>
              </span>

              <span>
                <h6>2.1 Monthly Plan</h6>
                <p>
                  Billed each month after the 30 days period, on a recurring
                  monthly basis.
                </p>
              </span>

              <span>
                <h6>2.2 Annual Plan</h6>
                <p>
                  Billed upfront once per year after the 30 days period, on a
                  recurring annual basis (often at a discounted rate compared to
                  monthly).<br />By entering your payment information when
                  signing up, you agree that once your 30 days ends, AIVOR will
                  automatically charge the applicable subscription fee (monthly
                  or annual, depending on your choice) to your provided payment
                  method. Auto-Renewal: Subscriptions automatically renew at the
                  end of each billing cycle (monthly or yearly) unless you
                  cancel before the next renewal date. We will continue to bill
                  your payment method for successive subscription periods until
                  you cancel.
                </p>
              </span>

              <span>
                <h6>3. PAYMENT AND BILLING</h6>
                <p>
                  You must provide up-to-date and accurate payment information
                  (such as a credit or debit card) when you sign up for the
                  Service (even during the 30 days). No charges will be made
                  during the 30-day trial period. Billing Commencement: Your
                  provided payment method will be charged at the end of the
                  trial period (unless you cancel before the trial ends) and
                  thereafter at the beginning of each subscription period.<br />All
                  prices are listed in Republic of South African Rand (ZAR) and
                  include any applicable taxes (including Value-Added Tax [VAT])
                  unless stated otherwise. By subscribing, you authorize AIVOR
                  to charge your chosen payment method for the subscription fees
                  on a recurring basis. If a payment is not successfully
                  processed (due to expiration, insufficient funds, or
                  otherwise), we may attempt to contact you and retry the
                  payment. If payment remains unpaid, we reserve the right to
                  suspend or terminate your access to the Service until billing
                  issues are resolved.
                </p>
              </span>

              <span>
                <h6>4. CANCELLATION AND REFUND POLICY</h6>
                <p></p>
              </span>

              <span>
                <h6>4.1 Cancellation</h6>
                <p>
                  You may cancel your subscription at any time. Cancellation
                  will prevent future renewal charges. If you cancel during the
                  30 days, your account will not be charged and will simply
                  deactivate after the trial period ends. If you cancel a paid
                  subscription, you will continue to have access to the Service
                  until the end of your current paid billing period (month or
                  year) that you have already paid for.
                </p>
              </span>

              <span>
                <h6>4.2 No Refunds</h6>
                <p>
                  Subscription fees (monthly or annual) are generally
                  non-refundable. This means that if you cancel in the middle of
                  a paid period, you will not receive a refund for the remaining
                  days or months, but you will retain access until the period
                  expires. We offer the 30-day trial so you can evaluate the
                  Service before any payment is charged. In cases of billing
                  errors or special circumstances (as required by Republic of
                  South African law or at our discretion), please contact
                  customer support - we will review refund requests on a
                  case-by-case basis.
                </p>
              </span>

              <span>
                <h6>5. USE OF THE SERVICE AND USER ACCOUNTS</h6>
                <p>
                  When you create an account, you must provide truthful,
                  accurate information about yourself and/or your business. You
                  are responsible for maintaining the confidentiality of your
                  login credentials and for all activities that occur under your
                  account. Notify us immediately if you suspect any unauthorized
                  use of your account.<br />By using AIVOR, you agree to use the
                  Service only for legitimate, lawful purposes related to your
                  business's costing and pricing activities. Prohibited Conduct:
                  You must not:<br />Use the Service in violation of any laws or
                  regulations.<br />Allow anyone else to use your account in
                  violation of these terms.<br />Attempt to copy, modify,
                  reverse engineer, or otherwise tamper with the Service or its
                  software.<br />Upload or input any harmful or malicious
                  content into the Service, or attempt to disrupt or interfere
                  with AIVOR's systems.<br />We reserve the right to suspend or
                  terminate your access if you violate these rules or any other
                  provision of these Terms and Conditions.
                </p>
              </span>

              <span>
                <h6>6. DATA USAGE AND POLICY</h6>
                <p></p>
              </span>

              <span>
                <h6>6.1 Personal and Business Data</h6>
                <p>
                  In order to provide the Service, AIVOR will collect and
                  process data that you input, which may include personal
                  information (such as your name and contact details) and
                  business data (such as cost figures, prices, or other
                  financial inputs you provide for calculation). By using the
                  Service, you consent to our collection, use, and storage of
                  this information for the purpose of operating the Service and
                  as described here and in our Privacy Policy.
                </p>
              </span>

              <span>
                <h6>6.2 Use of Entered Data</h6>
                <p>
                  All data you enter into the Service may be used by AIVOR in an
                  anonymized, aggregated form for analytical, demographic, and
                  service improvement purposes. This means we may analyse
                  overall usage trends or average figures across many users to
                  improve our algorithms or gain business insights, but we will
                  not disclose any of your personal or business identifiable
                  information to third parties without your consent. We will
                  handle your data in compliance with applicable data protection
                  laws, including the Republic of South African Protection of
                  Personal Information Act (POPIA). For more details on how we
                  protect and use your data, please refer to our Privacy Policy
                  (available on our website/app).
                </p>
              </span>

              <span>
                <h6>6.3 Third-Party Services</h6>
                <p>
                  We may use third-party services (such as payment processors or
                  cloud hosting providers) as part of delivering the Service.
                  These third parties may have access to certain personal
                  information as necessary for their role (for example,
                  processing your payment or storing data). We ensure that such
                  partners are bound by appropriate data protection obligations
                  and only use your information for the purposes of providing
                  their services to us.
                </p>
              </span>

              <span>
                <h6>7. INTELLECTUAL PROPERTIES</h6>
                <p>
                  All rights, title, and interest in and to the AIVOR Service
                  (including the software, algorithms, designs, and content
                  provided through the Service) are owned by AIVOR Pty Ltd or
                  our licensors. We grant you a limited, non-exclusive,
                  non-transferable license to use the Service for your own
                  internal business purposes, in accordance with these Terms.
                  You do not acquire any ownership of the software or other
                  intellectual property by using the Service.<br />"AIVOR" and
                  our logos, as well as other trademarks and service marks that
                  we use in connection with the Service, are the property of
                  AIVOR Pty Ltd. You are not permitted to use our name or
                  branding for any purpose (including marketing or promotions)
                  without our prior written consent.<br />Any feedback,
                  suggestions, or ideas you provide to us regarding the Service
                  are completely voluntary, and you agree that AIVOR may use
                  such feedback freely and without any obligation to you. This
                  helps us improve the Service and develop new features.
                </p>
              </span>

              <span>
                <h6>8. DISCLAMERS AND LIMITATIONS OF LIABILITY</h6>
                <p></p>
              </span>

              <span>
                <h6>8.1 No Guarantee of Results</h6>
                <p>
                  Our Service utilizes artificial intelligence to provide cost
                  and pricing suggestions, but we do not guarantee that the
                  results or recommendations will be 100% accurate, appropriate,
                  or suitable for your specific situation. The Service is a tool
                  to assist you, but it should not replace your own judgment or
                  professional advice. You are responsible for all business
                  decisions you make, including any based on information from
                  our Service.
                </p>
              </span>

              <span>
                <h6>8.2 "As-Is" Service</h6>
                <p>
                  The Service is provided on an "as is" and "as available"
                  basis. While we strive to maintain a high-quality and reliable
                  platform, AIVOR makes no warranties or representations,
                  express or implied, about the accuracy, reliability,
                  completeness, or timeliness of the Service. To the fullest
                  extent permitted by law, we disclaim any implied warranties,
                  including but not limited to warranties of merchantability and
                  fitness for a particular purpose. In plain language, this
                  means we cannot promise the Service will meet all your
                  expectations or that it will be error-free and uninterrupted
                  at all times.
                </p>
              </span>

              <span>
                <h6>8.3 Limitation of Liability</h6>
                <p>
                  To the maximum extent allowed by applicable law, AIVOR Pty Ltd
                  (including its directors, employees, and agents) will not be
                  liable for any indirect, special, incidental, or consequential
                  damages arising out of or related to your use of the Service.
                  This includes, for example, loss of profits, loss of data,
                  business interruption, or costs incurred due to decisions you
                  made based on information from the Service. In any event, if
                  AIVOR is found responsible for any claim arising from the
                  Service, our total liability to you will not exceed the amount
                  you have paid us in subscription fees in the past twelve (12)
                  months preceding the claim (or, if you are still in the 30
                  days or have not paid any fees, our liability is limited to
                  the amount of R0). Some jurisdictions do not allow the
                  exclusion or limitation of certain liabilities - in such
                  cases, our liability will be limited to the fullest extent
                  permitted by law.
                </p>
              </span>

              <span>
                <h6>8.4 Indemnification</h6>
                <p>
                  You agree that if a third party makes a claim against AIVOR
                  due to your actions - for example, your misuse of the Service
                  or your violation of these Terms (including any use of the
                  Service that infringes someone else's rights or violates the
                  law) - then you will defend, indemnify, and hold AIVOR
                  harmless from any such claim. This means you will be
                  responsible for any loss or damage we suffer, including legal
                  fees, as a result of your misuse of the Service. (In simpler
                  terms, if your use of our Service causes harm or legal issues
                  for anyone, you need to take responsibility for it, not
                  AIVOR.)
                </p>
              </span>

              <span>
                <h6>9. CUSTOMER SUPPORT AND CONTACT INFORMATION</h6>
                <p>
                  We are committed to supporting our users. If you encounter any
                  issues with the Service, have questions about your
                  subscription, or need assistance, you can contact our customer
                  support team. Support Contact: You can reach us by email at
                  support&#64;aivor.com or by phone at +27 82 820 2344 or +27 83 276
                  4490. We aim to respond to customer inquiries in a timely
                  manner and will do our best to resolve any problems you report
                  with the Service.<br />For billing or account issues
                  (including upgrade, downgrade, or cancellation requests), you
                  may also reach out to us via the above contact information or
                  use the account management features on our website/app.
                </p>
              </span>

              <span>
                <h6>10. GOVERNING LAW</h6>
                <p>
                  These Terms and Conditions are governed by the laws of the
                  Republic of South Africa. By agreeing to these terms, you
                  consent that in the event of any dispute or claim arising out
                  of or related to these Terms or your use of the Service, such
                  dispute will be subject to the exclusive jurisdiction of the
                  courts of Republic of South Africa. Nothing in this section
                  limits any rights you may have under Republic of South African
                  consumer protection laws, to the extent those laws are
                  applicable.
                </p>
              </span>

              <span>
                <h6>11. ACKNOWLEDGEMENT AND AGREEMENT</h6>
                <p>
                  By clicking "I Agree," "Sign Up," or a similar button (or by
                  otherwise indicating your acceptance), you acknowledge that
                  you have read, understood, and agree to these Terms and
                  Conditions. If you are signing up on behalf of a company or
                  other legal entity, you represent that you have the authority
                  to bind that entity to these terms.<br />Please also review
                  our Terms of Service (Full Agreement) and Privacy Policy
                  available on our website or app for more detailed information.
                  These documents contain additional terms and details that
                  govern your use of the Service. Together, these Terms and
                  Conditions, the full Terms of Service, and our Privacy Policy
                  constitute the entire agreement between you and AIVOR
                  regarding the Service.
                </p>
              </span>

              <span>
                <h6>12. TERMS OF SERVICE (Full Agreement)</h6>
                <p></p>
              </span>

              <span>
                <h6>12.1 Introduction</h6>
                <p>
                  Welcome to AIVOR! These Terms of Service ("Terms" or
                  "Agreement") govern your access to and use of AIVOR Pty Ltd
                  AI-based costing and pricing software services, including our
                  website and mobile application (collectively, "the Service").
                  This is a legally binding agreement between you (the
                  individual or entity using the Service) and AIVOR Pty Ltd, a
                  private limited company registered in Republic of South Africa
                  with registration number 2024/781270/07 ("AIVOR," "we," "us,"
                  or "our").<br />By using or accessing the Service, you confirm
                  that you have read, understood, and agree to be bound by these
                  Terms of Service. If you do not agree with any part of these
                  Terms, you must not use the Service.<br />If you are using the
                  Service on behalf of a company or other organization, you
                  represent that you have the authority to bind that
                  organization to these Terms. In such a case, all references to
                  "you" or "your" in this Agreement refer to the organization
                  and its authorized users.
                </p>
              </span>

              <span>
                <h6>12.2 Geographic Scope</h6>
                <p>
                  AIVOR currently offers the Service only to users located in
                  the Republic of South Africa. We make no representation that
                  the Service is available or appropriate in other locations. If
                  you access or use the Service from outside Republic of South
                  Africa, you do so on your own initiative and are responsible
                  for compliance with any local laws.
                </p>
              </span>

              <span>
                <h6>13. ACCOUNTS AND ELIGIBILITY</h6>
                <p>
                  To use our Service, you must create an account and provide
                  certain information. You agree to provide accurate, current,
                  and complete information during registration and to keep this
                  information updated as needed. This includes providing a valid
                  email address and any other information we require to set up
                  your account.
                </p>
              </span>

              <span>
                <h6>13.1 Eligibility Requirements</h6>
                <p>
                  You must be at least 18 years old (or the legal age of
                  majority in your jurisdiction) to create an account, or you
                  must have the involvement and consent of a parent or legal
                  guardian. If you create an account on behalf of a company or
                  organization, you must have the authority to do so and to bind
                  the entity to these Terms. The Service is intended for use by
                  small businesses and their authorized representatives within
                  Republic of South Africa. By using the Service, you confirm
                  that you meet these eligibility criteria.
                </p>
              </span>

              <span>
                <h6>13.2 Account Security</h6>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account login credentials. You must not share your
                  username or password with unauthorized persons, and you agree
                  to notify us immediately at the support contact information
                  below if you suspect any unauthorized access to or use of your
                  account. AIVOR will not be liable for any loss or damage
                  arising from your failure to safeguard your account
                  credentials.
                </p>
              </span>

              <span>
                <h6>14. 30 DAYS FOR R1.00</h6>
                <p>
                  When you first register for the Service, you may engage with
                  the web-based software system for 30 days prior to a monthly
                  recurring amount for 12 months. The 30-day demo stage is
                  intended to allow new users to try the Service without risk or
                  obligation. During the 30 days, you will have access to the
                  Service's features just as a paid subscriber would, though we
                  reserve the right to impose certain usage limits during the
                  trial if necessary (for example, to prevent abuse of the
                  trial).
                </p>
              </span>

              <span>
                <h6>14.1 Eligibility</h6>
                <p>
                  The 30-day demo stage is available to new customers for one
                  time only. If you (or your business) have already received a
                  30-day period of AIVOR in the past, we reserve the right to
                  decline to offer another trial.
                </p>
              </span>

              <span>
                <h6>14.2 R1 Charge During 30-day period</h6>
                <p>
                  You will be charged a subscription fee of R1 during the 30-day
                  period. However, you are required to provide a payment method
                  at the start of the demo to ensure a seamless transition to a
                  paid plan if you choose to continue using the Service after
                  the 30-day period.
                </p>
              </span>

              <span>
                <h6>14.3 Transition to Paid Subscription</h6>
                <p>
                  Unless you cancel before the end of the 14th-day period, your
                  demo will automatically convert to a paid subscription on the
                  day immediately after the demo period ends. At that time, we
                  will charge your provided payment method for the subscription
                  plan you selected at sign-up monthly or annually. If you did
                  not select a plan, the default will be the monthly plan.
                </p>
              </span>

              <span>
                <h6>14.4 Cancellation During Trial Period</h6>
                <p>
                  If you decide not to continue with the Service, you must
                  cancel before the period expires (by 11:59 PM on the 14th day
                  of the period) to avoid being charged. You can cancel via your
                  account settings on the website/app or by contacting AIVOR
                  support. If you cancel within the period, your account will be
                  downgraded or deactivated once the 30-day period is over, and
                  you will not be billed.
                </p>
              </span>

              <span>
                <h6>15. SUBSCRIPTION PLANS AND BILLING</h6>
                <p>
                  After the 30 days, continued use of the Service requires a
                  paid subscription. We offer the following subscription
                  options:
                </p>
              </span>

              <span>
                <h6>15.1 Monthly Subscription</h6>
                <p>
                  You will be billed monthly, in advance, on a rolling basis.
                  The first payment is charged at the end of your 30 days (if
                  you continue with the Service), and subsequent payments will
                  be charged on the same day of each month thereafter (for
                  example, if your paid subscription starts on the 5th of a
                  month, subsequent charges occur on the 5th of each following
                  month).
                </p>
              </span>

              <span>
                <h6>15.2 Annual Subscription</h6>
                <p>
                  You will be billed once per year, in advance. The first annual
                  payment is charged at the end of the 30 day period (if you
                  continue with an annual plan), and subsequent renewals will be
                  charged on the yearly anniversary of that date. Annual plans
                  may offer a discounted rate compared to 12 months of the
                  monthly plan.
                </p>
              </span>

              <span>
                <h6>15.3 Payment Method</h6>
                <p>
                  You must provide a valid payment method (such as a credit card
                  or debit card) to pay for the subscription. By providing your
                  payment details, you represent that you are authorized to use
                  the payment method and you authorize AIVOR (or our third-party
                  payment processor) to charge the subscription fees to that
                  payment method.
                </p>
              </span>

              <span>
                <h6>15.4 Auto-Renewal</h6>
                <p>
                  Your subscription will automatically renew at the end of each
                  billing period (monthly or yearly, depending on your plan)
                  unless you cancel your subscription before the next renewal
                  date. By default, you agree that we may automatically charge
                  you for each renewal term. For annual subscriptions, we will
                  send you a reminder notice (for example, via email) before
                  renewing your subscription for another year. For monthly
                  subscriptions, we may not send a monthly reminder, so please
                  note the renewal dates.
                </p>
              </span>

              <span>
                <h6>15.5 Price Changes</h6>
                <p>
                  AIVOR may change the subscription fees for future subscription
                  periods. If the price of your subscription is due to change
                  upon renewal, we will give you advance notice of the new fee
                  (for example, by email or via a notice in the app) and the
                  date it will become effective. If you do not agree to the
                  price change, you must cancel your subscription before the new
                  price takes effect. If you continue to use the Service without
                  cancelling, the new fee will be charged to your payment method
                  on the next billing date.
                </p>
              </span>

              <span>
                <h6>15.6 Taxes</h6>
                <p>
                  All fees are charged in Republic of South African Rand (ZAR).
                  Our prices include Value Added Tax (Value-Added Tax (VAT)) and
                  any other applicable taxes unless we indicate otherwise. If
                  for some reason a tax is not included and is applicable, you
                  are responsible for paying such tax. We will clearly display
                  the total charges (including any taxes) at the time of
                  payment.
                </p>
              </span>

              <span>
                <h6>16. PAYMENTS AND INVOICING</h6>
                <p>
                  Subscription fees are due and payable in advance of each
                  subscription term. When your paid subscription begins
                  (immediately after the trial period if you do not cancel), the
                  first subscription payment will be processed. Thereafter:<br />For
                  monthly plans, the charge will occur on the same calendar day
                  each month as when your subscription started. If a month is
                  shorter and does not have that date (e.g., 31st), the charge
                  will occur on the last day of that month.<br />For annual
                  plans, the charge will occur on the anniversary of your
                  subscription start date each year.
                </p>
              </span>

              <span>
                <h6>16.1 Payment Processing</h6>
                <p>
                  Payments will be processed by AIVOR or by a third-party
                  payment processor on our behalf. We do not store your full
                  credit card details on our own servers; storage and handling
                  of payment information are managed by our PCI-DSS-compliant
                  payment provider. By submitting your payment information, you
                  agree to the payment processor's terms and authorize us to
                  charge the applicable fees to your payment method.
                </p>
              </span>

              <span>
                <h6>16.2 Invoices and Receipts</h6>
                <p>
                  Upon successful payment, we will provide a receipt or invoice
                  for your records, usually by email or accessible through your
                  account dashboard. This document will outline the amount
                  charged and the subscription period it covers.
                </p>
              </span>

              <span>
                <h6>16.3 Failed Payments</h6>
                <p>
                  If a charge is declined or fails (for example, due to an
                  expired card or insufficient funds), we will notify you and
                  may automatically retry the payment. Please ensure your
                  payment information is current and accurate. If payment is not
                  completed within a short period after the due date, AIVOR may
                  suspend your access to the Service until the account balance
                  is settled. You are responsible for any amounts that remain
                  unpaid. AIVOR reserves the right to terminate your
                  subscription if fees remain unpaid for an extended period and
                  you do not respond to payment reminders.
                </p>
              </span>

              <span>
                <h6>17. CANCELLATION AND TERMINATION</h6>
                <p></p>
              </span>

              <span>
                <h6>17.1 Your Right to Cancel</h6>
                <p>
                  You may cancel your AIVOR subscription at any time. You can
                  cancel through your account settings on our website/app or by
                  contacting customer support. Cancellation will stop future
                  subscription renewals:<br />If you cancel a monthly
                  subscription, you will not be billed for any subsequent
                  months. You will retain access to the Service until the end of
                  the current monthly billing cycle that you have already paid
                  for.<br />If you cancel an annual subscription, you will not
                  be billed for the next year. You will continue to have access
                  until the end of the current annual term that you have paid
                  for.<br />To avoid being charged for the next period, you must
                  cancel before your next billing date. Once cancelled, we will
                  confirm your cancellation, and no further recurring charges
                  will be made, unless you reactivate your subscription.
                </p>
              </span>

              <span>
                <h6>17.2 Refunds</h6>
                <p>
                  As noted above, payments are non-refundable except where
                  required by law or at our discretion in extraordinary cases.
                  We do not routinely provide refunds or credits for any partial
                  subscription period or unused Service. For instance, if you
                  cancel partway through a month or year, you will not receive a
                  refund for the remainder of that period. We provide the 30
                  days to ensure the Service meets your needs before you are
                  charged. However, if you believe a billing error has occurred
                  or you have a special circumstance, please contact support. We
                  will review such requests and, if the situation warrants, we
                  may provide a refund or credit on a case-by-case basis.
                </p>
              </span>

              <span>
                <h6>17.3 Termination by AIVOR</h6>
                <p>
                  We reserve the right to suspend or terminate your access to
                  the service if:<br />You breach any of these Terms of Service
                  or violate any applicable law or regulation in connection with
                  your use of AIVOR.<br />Your payment for the subscription is
                  overdue and remains unpaid despite notice from us.<br />We
                  detect fraudulent or suspicious activity, or misuse of the
                  Service (for example, actions that could harm other users, our
                  systems, or violate the Acceptable Use Policy). We decide to
                  discontinue the Service (in which case we will provide you
                  with notice and, if you have a paid subscription, a pro-rated
                  refund for the remaining portion of your subscription).<br />In
                  most cases, if the issue is something that can be remedied, we
                  will attempt to notify you and give you a chance to resolve
                  the problem before terminating. However, for serious
                  violations or legal requirements, immediate termination may be
                  necessary.<br />If we terminate your account due to a breach
                  of these Terms or misconduct, you will not be entitled to any
                  refund of fees paid.
                </p>
              </span>

              <span>
                <h6>17.4 Effect of Termination</h6>
                <p>
                  Upon termination or cancellation of your account, your right
                  to use the Service will stop. We may disable or delete your
                  account and all associated data. It is your responsibility to
                  export or back up any important data from the Service before
                  your account ends. We are not obligated to retain your data
                  after termination, except as required by law. However, even
                  after your account is deleted, some residual copies of your
                  data might remain in our backup systems for a short period,
                  but these will be purged in accordance with our data retention
                  policies.
                </p>
              </span>

              <span>
                <h6>18. USER DATA AND PRIVACY</h6>
                <p>
                  Your privacy and data security are important to us. Our
                  practices regarding your personal information and business
                  data are described in our Privacy Policy. By using the
                  Service, you agree that we can collect, use, and share your
                  information as outlined in these Terms and our Privacy Policy.
                </p>
              </span>

              <span>
                <h6>18.1 Data You Provide</h6>
                <p>
                  In using the Service, you will provide various data, including
                  information about your business (costs, prices, etc.) and
                  personal details needed to create your account (name, email,
                  etc.). You retain ownership of all the data you input into
                  AIVOR ("User Data"). We do not claim ownership over your User
                  Data. You are responsible for ensuring you have the rights or
                  permissions needed to use and input any data into the
                  Service.<br />By using the Service, you grant AIVOR permission
                  (a license) to process your User Data for the purpose of
                  providing the Service to you and any related purposes
                  described in these Terms or our Privacy Policy. This includes,
                  for example, displaying the data back to you in reports,
                  running it through our algorithms to generate results, and
                  storing it on our servers.
                </p>
              </span>

              <span>
                <h6>18.2 Use of Data for Analytics</h6>
                <p>
                  AIVOR is continually improving its software. One way we do
                  this is by analysing how the Service is used. You agree that
                  AIVOR may use data entered into the Service in an aggregated
                  and anonymized manner for analytical purposes, product
                  improvement, and to generate industry or market insights. For
                  instance, we might compute average costs or pricing markups
                  across all users in a certain sector. When doing this, we will
                  not reveal any personally identifying information or any
                  specific business's data to other parties. Aggregated data
                  means it's combined with data from other users, and anonymized
                  means we've removed details that identify you.
                </p>
              </span>

              <span>
                <h6>18.3 Protection of Personal Information</h6>
                <p>
                  AIVOR will treat your personal information (and any personal
                  information about others that may be contained in your
                  business data) in accordance with Republic of South Africa's
                  Protection of Personal Information Act (POPIA) and our Privacy
                  Policy. We implement reasonable and appropriate security
                  measures to safeguard your data from unauthorized access or
                  disclosure. However, no method of transmission over the
                  internet or electronic storage is completely secure, so we
                  cannot guarantee absolute security.<br />We will not sell your
                  personal information to third parties. We will not share your
                  information with third parties except (a) as needed to provide
                  the Service (for example, using a cloud hosting provider to
                  store data or a payment processor to handle billing), (b) as
                  required by law or legal process, or (c) with your consent.<br />If
                  you have questions about how we handle data or wish to
                  exercise any rights you might have (such as accessing or
                  deleting your personal information), please refer to our
                  Privacy Policy or contact us using the information provided in
                  the Contact section of these Terms.
                </p>
              </span>

              <span>
                <h6>19. LICENCE AND INTELLECTULA PROPERTY RIGHTS</h6>
                <p></p>
              </span>

              <span>
                <h6>19.1 License to Use the Service</h6>
                <p>
                  Subject to your compliance with these Terms and payment of any
                  applicable fees, AIVOR grants you a limited, non-exclusive,
                  non-transferable, and revocable license to access and use the
                  Service for your internal business purposes. This license
                  allows you to use our web application and mobile app, and to
                  input and retrieve your business data through the Service. You
                  agree not to use the Service for any purpose other than as
                  intended and permitted by AIVOR.
                </p>
              </span>

              <span>
                <h6>19.2 AIVOR's Intellectual Property</h6>
                <p>
                  All content, software, technology, and materials included in
                  the Service or provided by AIVOR (collectively, "AIVOR
                  Materials") are owned by AIVOR Pty Ltd or our licensors and
                  are protected by copyright, trademark, patent, trade secret,
                  and other intellectual property laws. This includes (but is
                  not limited to) the software code, algorithms, design
                  elements, logos, text, graphics, and compilations of data used
                  in the Service.<br />You agree not to copy, distribute,
                  modify, create derivative works of, publicly display, publicly
                  perform, or otherwise use any AIVOR Materials except as
                  necessary for your use of the Service in compliance with these
                  Terms. You also agree not to remove or alter any copyright
                  notices or other proprietary markings in the Service.<br />"AIVOR"
                  and all associated logos and product names are trademarks of
                  AIVOR Pty Ltd. You are not granted any right or license to use
                  any trademarks of AIVOR without our express written consent,
                  except as needed to identify the Service you are using.
                </p>
              </span>

              <span>
                <h6>19.3 User Content and Feedback</h6>
                <p>
                  Aside from the business data you input for your own use, if
                  you choose to provide feedback, suggestions, or other
                  communications to AIVOR about the Service ("Feedback"), you
                  grant AIVOR a worldwide, perpetual, irrevocable,
                  sublicensable, and royalty-free license to use and incorporate
                  your Feedback in our products and services. This means, for
                  example, if you suggest a new feature or improvement, we can
                  use your idea without compensating you. We will not publicly
                  attribute feedback or testimonials to you without your
                  consent.
                </p>
              </span>

              <span>
                <h6>20. ACCEPTABLE USE POLICY</h6>
                <p>
                  By using the Service, you agree to this Acceptable Use Policy
                  and you are responsible for use of AIVOR by you and anyone
                  accessing the Service via your account. You must use the
                  Service in a lawful manner and with respect for the rights of
                  others. Specifically, you agree NOT to:
                </p>
              </span>

              <span>
                <h6>20.1 Break the Law</h6>
                <p>
                  Use the Service to violate any law or regulation, or to
                  promote any illegal activities.
                </p>
              </span>

              <span>
                <h6>20.2 Violate Rights of Others</h6>
                <p>
                  Upload or input any information or material into the Service
                  that infringes any third party's rights (such as another
                  person's confidential information, copyright, or personal data
                  without permission). You also will not use the Service to
                  defame, harass, or abuse anyone.
                </p>
              </span>

              <span>
                <h6>20.3 Harm Security</h6>
                <p>
                  Attempt to probe, scan, or test the vulnerability of the
                  Service or any related system or network, or breach any
                  security or authentication measures. You will not transmit any
                  worms, viruses, or any code of a destructive nature.
                </p>
              </span>

              <span>
                <h6>20.4 Disrupt the Service</h6>
                <p>
                  Interfere with or disrupt the Service or servers or networks
                  connected to the Service. This includes not engaging in
                  denial-of-service attacks, not artificially overloading the
                  Service, and not using any automated systems (like bots,
                  scrapers, or scripts) to excessively call the Service in a way
                  that could impair its performance for other users.
                </p>
              </span>

              <span>
                <h6>20.5 Misuse Accounts</h6>
                <p>
                  Share your account with multiple users or persons not
                  authorized by us, or use another user's account without
                  permission. Each user should have their own account
                  credentials.
                </p>
              </span>

              <span>
                <h6>20.6 Reverse Engineer or Misappropriate</h6>
                <p>
                  Attempt to reverse engineer, decipher, decompile, or
                  disassemble any of the software used to provide the Service,
                  except to the extent that such activity is expressly permitted
                  by applicable law despite this limitation. Also, you must not
                  use the Service to develop a competing product or service or
                  copy features or user interfaces of the Service.<br />If you
                  engage in any of the prohibited activities above or otherwise
                  violate these Terms, AIVOR may suspend or terminate your
                  account, and you may be subject to legal action. We may also
                  cooperate with law enforcement and other authorities in
                  investigating any violations of law.<br />We value fair and
                  reasonable use of our Service. If your usage is significantly
                  excessive or abusive (for example, if it threatens the
                  stability or security of our services), we reserve the right
                  to take appropriate measures, such as throttling your usage or
                  discussing alternative solutions with you.
                </p>
              </span>

              <span>
                <h6>21. SERVICE AVAILABILITY AND MODIFICATIONS</h6>
                <p>
                  AIVOR aims to provide a reliable and accessible Service, but
                  no system is perfect and uptime cannot be guaranteed. There
                  may be times when the Service is unavailable due to technical
                  problems, maintenance, or factors outside our control.
                </p>
              </span>

              <span>
                <h6>21.1 Maintenance and Updates</h6>
                <p>
                  We may from time to time perform maintenance or deploy updates
                  to the Service. We strive to schedule maintenance during
                  off-peak hours to minimize disruption. Whenever reasonably
                  possible, we will provide advance notice (for example, via an
                  announcement on our website or an email) for any scheduled
                  downtime or significant updates.
                </p>
              </span>

              <span>
                <h6>21.2 Beta Features</h6>
                <p>
                  Occasionally, AIVOR might offer preview or beta features as
                  part of the Service. These features are experimental and
                  provided on an as-is basis for evaluation. We may modify or
                  discontinue beta features at any time. Your use of beta
                  features is voluntary, and you understand that they might be
                  less reliable or change in ways that regular features do not.
                </p>
              </span>

              <span>
                <h6>21.3 Modifications to Service</h6>
                <p>
                  We reserve the right to modify the Service (for example, by
                  adding or removing features) or discontinue the Service (in
                  whole or in part) at any time. If we discontinue the Service
                  or any significant feature, we will try to give you advance
                  notice to allow you to export your data or adjust your usage.
                  If we discontinue the Service entirely, and you have time
                  remaining on a paid subscription, we will provide an
                  appropriate refund for the unused portion of your
                  subscription.
                </p>
              </span>

              <span>
                <h6>22. DISCLAIMERS AND WARRANTY</h6>
                <p></p>
              </span>

              <span>
                <h6>22.1 Use at Your Own Risk</h6>
                <p>
                  You understand that you use the Service at your own discretion
                  and risk. AIVOR uses advanced algorithms and aims to provide
                  helpful costing and pricing information, but the accuracy and
                  applicability of the results depend on many factors, including
                  the data you provide. You should not rely solely on the
                  Service for critical decisions.
                </p>
              </span>

              <span>
                <h6>22.2 No Warranties</h6>
                <p>
                  To the fullest extent permitted by law, AIVOR disclaims all
                  warranties of any kind, whether express, implied, or
                  statutory, regarding the Service. This includes, but is not
                  limited to:<br />Implied warranties of merchantability (that
                  the Service meets the standard of quality for use) and fitness
                  for a particular purpose (that the Service is suitable for
                  your specific needs).<br />Any warranty that the Service will
                  be uninterrupted, timely, secure, or error-free.<br />Any
                  warranty that the information (including any results,
                  suggestions, or calculations) obtained from the Service will
                  be accurate or reliable.<br />We provide the Service "as is"
                  and "as available". No advice or information, whether oral or
                  written, obtained by you from AIVOR or through the Service
                  shall create any warranty not expressly stated in these Terms.
                </p>
              </span>

              <span>
                <h6>22.3 Not Financial Advice</h6>
                <p>
                  The Service is not intended to replace professional financial,
                  accounting, or consulting advice. The suggestions and outputs
                  provided by the AI are based on the inputs and assumptions you
                  provide. Circumstances vary widely between businesses, and
                  what works for one may not work for another. Always consider
                  seeking advice from qualified professionals for complex
                  decisions. AIVOR is not responsible for any decisions you make
                  based on the Service's output.<br />Certain jurisdictions do
                  not allow the exclusion of certain warranties, so some of the
                  above disclaimers may not fully apply to you. In such cases,
                  any required warranties will apply to the minimum extent
                  required by law.
                </p>
              </span>

              <span>
                <h6>23. LIMITATION OF LIABILITY</h6>
                <p></p>
              </span>

              <span>
                <h6>23.1 No Indirect Damages</h6>
                <p>
                  To the maximum extent permitted by law, in no event will AIVOR
                  Pty Ltd, its affiliates, directors, officers, employees, or
                  agents be liable for any indirect, incidental, special,
                  consequential, or punitive damages arising out of or related
                  to your use of or inability to use the Service. This includes
                  any loss of profits or revenue, loss of business opportunity,
                  loss of data, or business interruption, even if we have been
                  advised of the possibility of such damages.
                </p>
              </span>

              <span>
                <h6>23.2 Cap on Liability</h6>
                <p>
                  To the extent permitted by law, AIVOR's total cumulative
                  liability to you for any direct damages or losses arising from
                  any claim related to the Service or these Terms will not
                  exceed the total amount of fees you have paid to AIVOR for the
                  Service in the twelve (12) months immediately preceding the
                  event giving rise to the claim. If no fees were paid (for
                  example, if you are in the trial period or using a free
                  service), AIVOR's total liability will be zero in such cases.
                  This limitation applies collectively to AIVOR, its
                  subsidiaries, affiliates, and their officers, employees, and
                  agents.
                </p>
              </span>

              <span>
                <h6>23.3 Exceptions</h6>
                <p>
                  We do not exclude or limit our liability to you where it would
                  be illegal to do so. For example, nothing in these Terms seeks
                  to limit liability for death or personal injury resulting from
                  our negligence, or for our fraudulent misrepresentation.
                  Additionally, if Republic of South African consumer protection
                  law applies to you, you may have certain rights that cannot be
                  excluded or limited, and nothing in these Terms is intended to
                  override those rights if applicable.<br />You acknowledge that
                  the fees paid (if any) for the Service reflect the allocation
                  of risk set forth in this agreement and that AIVOR would not
                  be able to provide the Service on an economically feasible
                  basis without these limitations.
                </p>
              </span>

              <span>
                <h6>24. INDEMNIFICATION</h6>
                <p>
                  You agree to indemnify, defend, and hold harmless AIVOR Pty
                  Ltd and its affiliates, and each of their respective officers,
                  directors, employees, and agents (the "AIVOR Parties"), from
                  and against any and all claims, liabilities, damages, losses,
                  and expenses (including reasonable attorneys' fees and costs)
                  that arise out of or relate to:<br />Your use or misuse of the
                  Service;<br />Your violation of any term of these Terms or any
                  policy referenced herein;<br />Your violation of any law or
                  regulation or the rights of any third party in connection with
                  your use of the Service.<br />This indemnification obligation
                  includes, for example, situations where a third party sues
                  AIVOR because of something you did. If you use AIVOR's Service
                  to do something illegal or infringe on someone's rights and
                  AIVOR is sued as a result, you would be responsible for the
                  costs and damages.<br />AIVOR reserves the right, at its own
                  expense, to assume the exclusive defence and control of any
                  matter otherwise subject to indemnification by you. In that
                  case, you agree to cooperate with AIVOR in defending such
                  matter. This indemnity obligation will survive the termination
                  or expiration of your account and these Terms.
                </p>
              </span>

              <span>
                <h6>25. GOVERNING LAW AND DISPUTE RESOLUTION</h6>
                <p>
                  These Terms of Service and any disputes arising out of or
                  relating to these Terms or the Service will be governed by the
                  laws of the Republic of South Africa, without giving effect to
                  any conflict of law principles.
                </p>
              </span>

              <span>
                <h6>25.1 Jurisdiction</h6>
                <p>
                  Both you and AIVOR agree that all legal claims or disputes
                  (unless otherwise agreed in writing by the parties) will be
                  brought exclusively in the courts of Republic of South Africa.
                  You and AIVOR consent to venue and personal jurisdiction in
                  such courts. If you are considered a consumer under Republic
                  of South African law, you might be entitled to bring disputes
                  in a forum nearer to your residence; this provision does not
                  override any such rights.
                </p>
              </span>

              <span>
                <h6>25.2 Good Faith Resolution</h6>
                <p>
                  Before filing a lawsuit or initiating other legal proceedings,
                  you and AIVOR agree to first try to resolve the dispute
                  informally in good faith. You can start by contacting us with
                  your dispute (using the contact information below) and we will
                  attempt to address your concerns. If we are unable to resolve
                  the issue informally, then either party may pursue formal
                  legal action.
                </p>
              </span>

              <span>
                <h6>25.3 Invalid Provisions</h6>
                <p>
                  If any provision of these Terms is held to be unlawful, void,
                  or unenforceable by a court, that provision will be deemed
                  severable from these Terms and will not affect the validity
                  and enforceability of the remaining provisions. The remaining
                  Terms will remain in effect.
                </p>
              </span>

              <span>
                <h6>26. CHANGES TO THESE TERMS</h6>
                <p>
                  AIVOR may update or modify these Terms of Service from time to
                  time. If we make material changes, we will notify users by
                  posting the updated Terms on our website (and/or within the
                  app) and by updating the "Last Updated" date at the top. In
                  certain cases, we may also send out additional notice (such as
                  an email notification or a prominent notice within the
                  Service) to inform you of significant changes.<br />It is
                  important that you review any updated Terms when we notify
                  you, because if you continue to use the Service after the
                  changes become effective, you are indicating that you accept
                  and agree to be bound by the revised Terms. If you do not
                  agree to the updated Terms, you should stop using the Service
                  and cancel any subscription as necessary.
                </p>
              </span>

              <span>
                <h6>27. ENTIRE AGREEMENT</h6>
                <p>
                  These Terms of Service, together with the shorter Terms and
                  Conditions you agreed to at sign-up and any other legal
                  notices or policies we incorporate by reference (such as our
                  Privacy Policy), constitute the entire agreement between you
                  and AIVOR regarding the Service. They supersede all prior
                  understandings or agreements (whether oral or written)
                  regarding the same subject matter.
                </p>
              </span>

              <span>
                <h6>27.1 No Waiver</h6>
                <p>
                  If AIVOR fails to enforce any right or provision of these
                  Terms, it will not be considered a waiver of such right or
                  provision. Any waiver of any provision of these Terms will be
                  effective only if in writing and signed by an authorized
                  representative of AIVOR.
                </p>
              </span>

              <span>
                <h6>27.2 Assignment</h6>
                <p>
                  You may not assign or transfer any of your rights or
                  obligations under these Terms to anyone else without our prior
                  written consent. We may assign our rights and obligations
                  under these Terms to an affiliate or in connection with a
                  merger, acquisition, sale of assets, or by operation of
                  law.<br />Nothing in this Agreement shall be construed to
                  create a partnership, joint venture, employment, or agency
                  relationship between you and AIVOR. Neither party has the
                  authority to bind the other or incur obligations on the
                  other's behalf without prior written consent.
                </p>
              </span>

              <span>
                <h6>28. CONTACT AND CUSTOMER SUPPORT</h6>
                <p>
                  If you have any questions, concerns, or feedback about these
                  Terms or the Service, please feel free to contact us. We are
                  here to help and we value our users' input.<br />Customer
                  Support Email: support&#64;aivor.com (for general inquiries or
                  support issues) Customer Support Phone: +27 82 820 2344 or +27
                  83 276 4490 (during business hours, if available) Business
                  Address: AIVOR Pty Ltd, 190 Circular Drive, Lorraine, 6070,
                  Republic of South Africa<br />We will do our best to respond
                  to support inquiries promptly (typically within 1-2 business
                  days). For urgent issues (such as problems accessing your
                  account or billing errors), please indicate the urgency when
                  you contact us, and we will prioritize helping you.
                </p>
              </span>

              <p>
                Thank you for choosing AIVOR to assist with your business's
                costing and pricing needs. By using our Service, you agree to
                these Terms of Service, and we are committed to providing you
                with a valuable tool to help your small business succeed.
              </p>

              <div class="form-group checkbox-group">
                <label class="checkbox-container">
                  <input
                    id="acceptTos"
                    type="checkbox"
                    formControlName="accepted"
                  />
                  <span class="checkmark"></span>
                  <span class="label-text">
                    I agree to the AIVOR Terms of Service and Privacy
                    Policy</span
                  >
                  <!-- <span>and I hereby authorize AIVOR Pty Ltd to:</span> -->

                  <!-- <div class="checkbox-details">
                    <ul>
                      <li>
                        Process a nominal R1 verification charge immediately to
                        validate my payment method for the 30-day Free Demo; and
                      </li>
                      <li>
                        Automatically charge R400 per month after the Demo
                        period ends, and on each renewal date thereafter, until
                        I cancel my subscription.
                      </li>
                    </ul>
                    <small>
                      I understand that my subscription is subject to a 12-month
                      minimum term and that charges will recur automatically
                      unless I cancel in accordance with the Terms of Service.
                    </small>
                  </div> -->
                </label>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button type="button" class="btn-secondary" (click)="prev()">
              Back
            </button>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="step3.invalid"
            >
              Next
            </button>
          </div>
        </form>

        <!-- STEP 4: Payment -->
        <form
          *ngIf="
            step === 4 && !isLoading && !registrationSuccess && !errorMessage
          "
          [formGroup]="step4"
          class="registration-form step4"
        >
          <div class="payment-container">
            <!-- Plan Selection -->
            <div class="payment-header">
              <h3 style="margin-top: 10px; margin-bottom: 0">
                Start Your 30-Day Free Trial
              </h3>
              <p class="verification-note">
                <strong>R1 verification fee</strong> (fully refundable) to
                confirm your card
              </p>
              <p class="trial-benefits">Full 30-day access • Cancel anytime</p>
            </div>

            <div *ngIf="loadingPlans" class="loading-plans">
              Loading plans...
            </div>
            <div *ngIf="!loadingPlans" class="plan-options">
              <div
                *ngFor="let plan of paystackPlans; let i = index"
                [class.selected]="selectedPlan?.id === plan.id"
                [class.recommended]="i === 1"
                (click)="selectPlan(plan)"
                class="plan-option"
              >
                <div class="plan-header">
                  <h2>{{ plan.name }}</h2>
                  <div *ngIf="i === 1" class="recommended-badge">
                    Recommended
                  </div>
                </div>
                <div class="price-container">
                  <span class="currency">{{ plan.currency || "R" }}</span>
                  <span class="price">{{ plan.amount }}</span>
                  <span class="interval">/{{ plan.interval || "mo" }}</span>
                </div>
                <div
                  *ngIf="plan.productDescription || plan.description"
                  class="description"
                >
                  {{ plan.productDescription || plan.description }}
                </div>
              </div>
            </div>

            <div *ngIf="paymentError" class="payment-error">
              <p>{{ paymentError }}</p>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn-secondary" (click)="prev()">
              Back
            </button>
            <button
              type="button"
              class="btn-success"
              [disabled]="!selectedPlan || paymentProcessing"
              (click)="processPayment()"
            >
              <span *ngIf="!paymentProcessing"> Proceed to Paystack </span>
              <span *ngIf="paymentProcessing">
                {{
                  paymentMethod === "paystack"
                    ? "Redirecting to Paystack..."
                    : "Processing..."
                }}
              </span>
            </button>
          </div>
        </form>
        <div *ngIf="paymentProcessing" class="loading-overlay">
          <div class="spinner"></div>
          <p>Processing your payment...</p>
        </div>
        <!-- Loading overlay -->
        <div *ngIf="isLoading" class="loading-overlay">
          <div class="spinner"></div>
          <p>Please Wait...</p>
        </div>

        <!-- Success message -->
        <div *ngIf="registrationSuccess" class="success-message">
          <div class="success-icon">✓</div>
          <h3>Registration Complete!</h3>
          <p>
            Thanks for registering! We're finalizing a few things on our end.
          </p>
          <p>
            A welcome email containing your password has been sent to your
            inbox.
          </p>
          <p class="redirect-message">
            You'll be automatically redirected to the login page. Once
            redirected, everything is complete, and you can log in using the
            details from your email.
          </p>
        </div>

        <!-- Error message -->
        <div *ngIf="errorMessage" class="error-message">
          <div class="error-icon">!</div>
          <h3>Registration Failed</h3>
          <p>{{ errorMessage }}</p>
          <button type="button" class="btn-primary" (click)="errorMessage = ''">
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
